import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck } from 'lucide-react';
import { Button } from './ui/Button';
const checkoutUrl = 'https://basketball-ready-system-365.impultienda.ar/checkout';
export function LastChance() {
  return <section className="relative overflow-hidden bg-navy-900 py-12 md:py-24" data-id="element-123">
      <div className="pointer-events-none absolute inset-0 bg-stadium-glow opacity-80" data-id="element-124" />

      <div className="container relative z-10 mx-auto px-4" data-id="element-125">
        <div className="max-w-3xl mx-auto text-center" data-id="element-126">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-127">
            <h2 className="mb-6 font-anton text-4xl uppercase tracking-wide text-white sm:text-5xl md:mb-8 md:text-6xl" data-id="element-128">
              LAST CHANCE
            </h2>

            <div className="prose prose-invert mx-auto mb-8 text-left text-base leading-7 text-gray-300 md:mb-12 md:text-center" data-id="element-129">
              <p className="text-base font-medium leading-7 text-white md:text-xl" data-id="element-130">
                Your players deserve the best version of you.
              </p>
              <p data-id="element-131">
                Not a coach improvising every basketball practice at the last
                minute.
              </p>
              <p data-id="element-132">
                Stop spending evenings searching for drills on social media.
                Stop building practices from scratch.
              </p>
              <p className="mt-6 text-lg font-medium text-gold-400 md:mt-8 md:text-xl" data-id="element-133">
                Take control of your season with a complete basketball coaching
                system designed to save time and develop better players.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="rounded-2xl border border-navy-700 bg-navy-950 p-4 shadow-2xl sm:p-6 md:p-12" data-id="element-134">
            <h3 className="mb-2 font-anton text-2xl uppercase tracking-normal text-white md:text-4xl md:tracking-wide" data-id="element-135">
              BASKETBALL READY: SYSTEM 365
            </h3>
            <p className="mb-5 font-oswald text-base uppercase tracking-wide text-gold-500 md:mb-8 md:text-xl md:tracking-widest" data-id="element-136">
              6 Complete Volumes + 5 Premium Bonuses
            </p>

            <div className="mb-6" data-id="element-137">
              <div className="mb-1 font-oswald text-base text-gray-400 line-through md:text-lg" data-id="element-138">
                Regular Price: USD 97
              </div>
              <div className="mb-1 font-oswald text-lg uppercase tracking-wide text-gold-500 md:text-xl md:tracking-widest" data-id="element-139">
                Today Only:
              </div>
              <div className="whitespace-nowrap font-anton text-[3rem] leading-none tracking-normal text-white sm:text-6xl md:tracking-wider" data-id="element-140">
                USD 27
              </div>
            </div>

            <div className="flex flex-col items-center gap-4 md:gap-6" data-id="element-141">
              <Button size="xl" fullWidth className="flex flex-col items-center" onClick={() => {
              ;
              (window as any).fbq?.('track', 'InitiateCheckout', {
                value: 27,
                currency: 'USD'
              });
              window.location.href = checkoutUrl;
            }} data-id="element-142">
                <span data-id="element-143">YES, I WANT BASKETBALL READY NOW →</span>
                <span className="mt-1 font-inter text-xs font-normal normal-case opacity-90" data-id="element-144">
                  Instant Access — Delivered By Email
                </span>
              </Button>

              <div className="flex flex-col items-center gap-3 px-1 text-center" data-id="element-145">
                <div className="flex flex-wrap items-center justify-center gap-1" data-id="element-146">
                  {[...Array(5)].map((_, index) => <Star key={index} className="h-5 w-5 fill-gold-500 text-gold-500" data-id="element-147" />)}
                  <span className="w-full font-oswald text-base text-gray-200 sm:ml-2 sm:w-auto sm:text-lg" data-id="element-148">
                    4.9/5 — Verified Reviews
                  </span>
                </div>
                <div className="flex items-center justify-center gap-2 text-center text-sm font-medium text-gray-400" data-id="element-149">
                  <ShieldCheck className="h-4 w-4 flex-shrink-0 text-green-500" data-id="element-150" />
                  <span data-id="element-151">7-Day Money Back Guarantee — Zero Risk</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}